export const nf = (n, d = 0) =>
    new Intl.NumberFormat("es-ES", {
        minimumFractionDigits: d,
        maximumFractionDigits: d,
    }).format(n);

export const smart = (n) => {
    if (!isFinite(n)) return "—";
    if (n >= 1e9) return `${nf(n / 1e9, 2)} mil millones`;
    if (n >= 1e6) return `${nf(n / 1e6, 1)} millones`;
    return nf(Math.round(n));
};

export const full = (n) => nf(Math.round(n));

export const decimal = (n, d = 1) => nf(n, d);
